/**
 * Discrete domains are converted into string[]
 * when using D3 scales
 * @param domain
 */
export default function parseDiscreteDomain(domain) {
  return domain.map(d => `${d}`);
}